/**
 * `IntelPane`: the dock body `AnalysisDock` swaps in once `#intelSelect` names a use case.
 * It shows the use case question and description, then the use case's own pane.
 *
 * NOTES #755 (client, 8 Oct 2026): the "How was this generated?" and Reset row that sat
 * under the description (last used by UC3 only) is gone. UC1 and UC2 open Methodology from
 * their own sub-tabs, and the one `#intelReset` is the button beside `#intelSelect`
 * (`UseCaseSelect.tsx`).
 */
import { useTranslation } from 'react-i18next';

import { useAppStore } from '../../lib/state';
import { Uc1 } from './Uc1';
import { Uc2 } from './Uc2';
import { Uc3 } from './Uc3';
import { useUseCases } from './api';

export function IntelPane() {
  const { t } = useTranslation();
  const useCase = useAppStore((s) => s.intel.useCase);
  const { data: useCases } = useUseCases();
  const meta = (useCases ?? []).find((uc) => uc.id === useCase);

  if (!useCase) return null;

  return (
    <div className="intel-pane" data-testid="intel-pane">
      {meta ? (
        <div className="intel-head intel-card">
          <h4 className="intel-card-title">{meta.question}</h4>
          {/* Layout round 2 Oct 2026: one muted line, clamped to two — the description is
              orientation, not the panel's content, and at full length it pushed the level
              switch and the chips below the fold on a 450 px dock. The full text stays in
              the DOM (and in the `title`) for anyone who wants it. */}
          <p className="intel-card-sub" title={meta.description}>
            {meta.description}
          </p>
        </div>
      ) : null}
      {useCase === 'uc1' ? (
        <Uc1 />
      ) : useCase === 'uc2' ? (
        <Uc2 />
      ) : useCase === 'uc3' ? (
        <Uc3 />
      ) : (
        <div className="note intel-comingsoon">{t('intel.comingSoon')}</div>
      )}
    </div>
  );
}

export default IntelPane;
